<template>
    <div>
        <!-- <section class="inner_banner">

        </section> -->

        <section class="contact_wrapp">
            <div class="container">
                <article class="row">
                    <aside class="col-md-8">
                        <div class="contact_form">
                            <h3>Contact Us</h3>
                            <form @submit="onSubmit">
                                <article class="row">
                                    <aside class="col-md-6">
                                        <div class="form-group">
                                            <label for="name">Name</label>
                                            <input id="name" v-model="form.name" type="text" class="form-control">
                                        </div>
                                    </aside>
                                    <aside class="col-md-6">
                                        <div class="form-group">
                                            <label for="email">Email</label>
                                            <input id="email" v-model="form.email" type="email" class="form-control">
                                        </div>
                                    </aside>
                                    <aside class="col-md-6">
                                        <div class="form-group">
                                            <label for="phone">Phone</label>
                                            <input id="phone" v-model="form.phone" type="tel" class="form-control">
                                        </div>
                                    </aside>
                                    <aside class="col-md-6">
                                        <div class="form-group">
                                            <label for="subject">Subject</label>
                                            <input id="subject" v-model="form.subject" type="text" class="form-control">
                                        </div>
                                    </aside>
                                    <aside class="col-md-12">
                                        <div class="form-group">
                                            <label for="message">Message</label>
                                            <textarea id="message" v-model="form.message" class="form-control"></textarea>
                                        </div>
                                    </aside>
                                </article>
                                <div class="contact_button">
                                    <button class="btn_blue">Submit</button>
                                </div>
                            </form>
                        </div>
                    </aside>
                    <aside class="col-md-4">
                        <div class="address_wrapp">
                            <h3>Follow Us on:</h3>
                            <ul class="social_icon">
                                <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                <li><a href="#"><i class="fab fa-instagram"></i></a></li>
                                <li><a href="#"><i class="fab fa-youtube"></i></a></li>
                            </ul>
                        </div>
                    </aside>
                </article>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'Contact',
    data () {
        return {
            form: {
                name: '',
                email: '',
                phone: '',
                subject: '',
                message: ''
            }
        }
    },
    methods: {
        onSubmit (e) {
            e.preventDefault()
            // console.log(this.form)
        }
    }
}
</script>

<style scoped>

</style>
